import { logError } from "common/error";
import { delay, Waiter } from "common/promises";
import { paths } from "from-start/scene/resources";
import { html, LitElement } from "lit-element";
import { nothing } from "lit-html";
import { classMap } from "lit-html/directives/class-map";
import { styleMap } from "lit-html/directives/style-map";
import log from "loglevel";
/**
 * 발생하는 이벤트들:
 * stateChanged({ newState })
 *   프리오프링에서 오프닝으로 바뀔 때 발생하매 newState = "opening"
 */
export class JhOpening extends LitElement {
    constructor() {
        super();
        this.showPlaySoundPopup = false;
        this.playSoundPopupClosed = new Waiter();
        this.state = "loading";
        this.showPopup = false;
    }
    static get properties() {
        return {
            state: { type: String, reflect: true },
            showPopup: { type: Boolean, attribute: "show-popup", reflect: true },
            showPlaySoundPopup: { type: Boolean, reflect: true },
        };
    }
    createRenderRoot() {
        return this;
    }
    render() {
        const hideOpening = this.state === "loading";
        const fadeOut = this.state === "fadeOut" || this.state === "finished";
        return html `
      <jh-full-div class="${classMap({ "fade-out": fadeOut })}">
        <jh-full-div class="${classMap({ dn: hideOpening })}">
          <img src="${paths.openingMainGif}" />
          <jh-opening-enter-button
            @click="${this.handleEnterButtonClick}"
          ></jh-opening-enter-button>
        </jh-full-div>

        ${this.showPopup ? this.createPopup() : ""}
        ${this.showPlaySoundPopup ? this.createPlaySoundPopup() : nothing}
      </jh-full-div>
    `;
    }
    createPlaySoundPopup() {
        const buttonStyle = {
            left: "201px",
            top: "903px",
            width: "309px",
            height: "80px",
        };
        return html `<img src="${paths.openingTurnOnSound}" />
      <button
        @click="${this.handlePlaySoundPopupClose}"
        class="absolute pointer-allow bg-transparent bn pointer"
        style="${styleMap(buttonStyle)}"
      ></button>`;
    }
    handlePlaySoundPopupClose() {
        this.showPlaySoundPopup = false;
        this.playSoundPopupClosed.trigger();
        this.playSoundPopupClosed.reset();
    }
    createPopup() {
        const buttonStyle = {
            left: "220px",
            top: "485px",
            width: "50px",
            height: "50px",
        };
        return html `
      <img src="${paths.openingPopupGif}" />
      <button
        @click="${this.handlePopupClose}"
        class="absolute pointer-allow bg-transparent bn"
        style="${styleMap(buttonStyle)}"
      ></button>
    `;
    }
    handlePopupClose() {
        this.showPopup = false;
    }
    handlePreOpeningClick() {
        this.changeState("opening");
    }
    async handleEnterButtonClick() {
        try {
            log.trace("opening enter button clicked");
            this.dispatchEvent(new CustomEvent("enterClick"));
            this.changeState("fadeOut");
            await delay(1500);
            log.trace("opening change state to finished");
            this.changeState("finished");
        }
        catch (e) {
            logError(e);
        }
    }
    changeState(newState) {
        this.state = newState;
        this.dispatchEvent(new CustomEvent("stateChanged", {
            detail: {
                newState,
            },
        }));
    }
}
customElements.define("jh-opening", JhOpening);
//# sourceMappingURL=opening.js.map